import React from "react";
import { StyledFileUploadInput } from "../../InputMol.styled";
function FileUploadInput(_ref) {
  var focus = _ref.focus,
    size = _ref.size,
    onColor = _ref.onColor,
    placeholder = _ref.placeholder,
    hasError = _ref.hasError,
    hasSuccess = _ref.hasSuccess,
    isLoading = _ref.isLoading,
    ctaWrapperWidth = _ref.ctaWrapperWidth,
    uploadedFilesNames = _ref.uploadedFilesNames,
    children = _ref.children;
  var hasUploadedFiles = !!uploadedFilesNames;
  var isPlaceholderVisible = !isLoading && !hasUploadedFiles;
  var isValueVisible = !isLoading;
  return /*#__PURE__*/React.createElement(StyledFileUploadInput, {
    $hasFocus: focus,
    $hasError: hasError,
    $hasSuccess: hasSuccess,
    $ctaWrapperWidth: ctaWrapperWidth,
    $onColor: onColor,
    $size: size
  }, children, placeholder && isPlaceholderVisible ? placeholder : null, isValueVisible ? /*#__PURE__*/React.createElement("span", null, uploadedFilesNames) : null);
}
export default FileUploadInput;